import React, { useRef, useEffect } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 */
const useOutsideAlerterwithClassName = (ref, props) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !event.target.classList.contains(props.classItem) && !ref.current.contains(event.target)) {
        props.handleOutSideClick();
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);
};

/**
 * Component that alerts if you click outside of it
 */
export default function OutsideAlerterwithClassName(props) {
  const wrapperRef = useRef(null);
  useOutsideAlerterwithClassName(wrapperRef, props);
  return <div ref={wrapperRef}>{props.children}</div>;
}
